import(/* webpackMode: "eager" */ "/src/src/app/_lens-components/style/client.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/frame-process/ClientPage.tsx");
